import { TFunction } from 'i18next';
import { loanStatusMapping } from '../../HbtMasterPoolTable/utils/LoanStatusMapping';

type FlatDataItem = {
  loanStatus: string;
};

export const statusOptionsGrouped = (flatData: FlatDataItem[], t: TFunction<'HbtMasterPool'>) => {
  const statusCountMap = new Map<string, number>();
  flatData.forEach((item) => {
    if (item.loanStatus === 'null' || item.loanStatus === undefined || item.loanStatus === null) {
      return;
    }
    const status = item.loanStatus;
    statusCountMap.set(status, (statusCountMap.get(status) || 0) + 1);
  });

  const mapping = loanStatusMapping(t);

  return Array.from(statusCountMap.entries()).map(([loanStatus, count]) => {
    const label = mapping[loanStatus as keyof typeof mapping];
    return {
      label,
      value: loanStatus,
      count,
      chipLabel: label
    };
  });
};
